import React from 'react';
import PropTypes from 'prop-types';

const OwnerType = ({ data }) => {
  let displayText = "";
  switch (data){
    case 1:
      displayText = "Lögfræðingur";
      break;
    case 2:
      displayText = "Kröfuhafi";
      break;
    case 3:
      displayText = "Skuldari";
      break;
    case 4:
      displayText = "Ríkið";
      break;
    default:
      displayText = "Ekki þekkt tegund";
      break;
  }
  return (
    <span>{displayText}</span>
  );
};

OwnerType.propTypes = {
  data: PropTypes.number,
};

export default OwnerType;
